module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-card', {
    staticClass: "mb-3",
    class: {
      'user-revoked-card': _vm.registrationCancelled, 'user-approved-card': _vm.registrationApproved
    },
    attrs: {
      "border-variant": _vm.registrationCancelled ? 'danger' : null,
      "header-border-variant": _vm.registrationCancelled ? 'danger' : null
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('userRegistration.registrationInstitution')))]), _vm._v(" "), _c('b-badge', {
    attrs: {
      "variant": _vm.priorityVariant[_vm.registration.status - 1]
    }
  }, [_vm._v(_vm._s(_vm.$t('userRegistration.registrationStatuses.' + _vm.registration.status)))])], 1), _vm._v(" "), _c('img', {
    ref: "imgToExport",
    staticClass: "p-1",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "src": require("@/assets/images/grb.svg")
    }
  }), _vm._v(" "), (_vm.registrationCancelled) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userRegistration.registrationCancelledUser')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.registration.cancelledUser))])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.registration.status) ? _c('b-row', [(_vm.registrationApproved) ? _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userRegistration.registrationApprovedUser')
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'userInformationPage',
        params: {
          userId: _vm.registration.approvedId
        }
      }
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_c('span'), _vm._v(_vm._s(_vm.registration.approvedUser))])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userRegistration.registrationRegistrationDate')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.formatShortDate(_vm.registration.creationDate)))])])], 1), _vm._v(" "), (_vm.registration.registrationDate) ? _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userRegistration.registrationApprovalDate')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.formatShortDate(_vm.registration.registrationDate)))])])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userRegistration.registrationId')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.registration.id))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userRegistration.registrationName')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.registration.name))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userRegistration.registrationAddress')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.registration.address))])])], 1)], 1), _vm._v(" "), (_vm.registrationPending) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('register.editRegistrationToken')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.registration.registrationToken))])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-row', [(_vm.isPublicEntity) ? _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userRegistration.registrationBudgetId')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.registration.companyNumber))])])], 1) : _vm._e(), _vm._v(" "), (_vm.isPublicEntity) ? _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userRegistration.registrationCompanyNumber')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.registration.budgetCompanyNumber))])])], 1) : _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userRegistration.registrationCompanyNumber')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.registration.companyNumber))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userRegistration.registrationTaxIdNumber')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.registration.taxIdNumber))])])], 1)], 1), _vm._v(" "), (_vm.registrationApproved) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('dashboard.liabilitiesRegistrationLimit')
    }
  }, [(_vm.registration.invoiceLimit) ? _c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.registration.invoiceLimit))]) : _c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.$t('userRegistration.noInvoiceLimitText')))]), _vm._v(" "), _c('i', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.editInvoiceLimitModal",
      modifiers: {
        "editInvoiceLimitModal": true
      }
    }],
    staticClass: "material-icons md-24",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_vm._v("edit")])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-btn', {
    attrs: {
      "type": "button",
      "variant": "success",
      "disabled": _vm.load
    },
    on: {
      "click": function($event) {
        return _vm.printRegistrationForm()
      }
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t('register.printRequestForm')) + "\r\n                "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mb-2",
    class: {
      'user-revoked-card': _vm.registrationCancelled, 'user-approved-card': _vm.registrationApproved
    },
    attrs: {
      "header": _vm.$t('userRegistration.registrationAdminActivate'),
      "border-variant": _vm.registrationCancelled ? 'danger' : null,
      "header-border-variant": _vm.registrationCancelled ? 'danger' : null
    }
  }, [_c('form', {
    ref: "accountApprovalForm",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.validateAccountApproval($event)
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userLogin')
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "userLoginField",
      "disabled": !_vm.registrationPending
    },
    model: {
      value: (_vm.registration.adminLogin),
      callback: function($$v) {
        _vm.$set(_vm.registration, "adminLogin", $$v)
      },
      expression: "registration.adminLogin"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userName')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.registration.adminName))])])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userEmail')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.registration.adminEmail))])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.registrationPending) ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.approveRegistrationConfirmationModal",
      modifiers: {
        "approveRegistrationConfirmationModal": true
      }
    }],
    attrs: {
      "variant": "success",
      "disabled": _vm.load
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t('userRegistration.registrationActivate')) + "\r\n                "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.registrationPending) ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.cancelRegistrationConfirmationModal",
      modifiers: {
        "cancelRegistrationConfirmationModal": true
      }
    }],
    attrs: {
      "variant": "info",
      "disabled": _vm.load
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t('userRegistration.registrationCancel')) + "\r\n                "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.registrationApproved) ? _c('b-btn', {
    attrs: {
      "type": "button",
      "variant": "success",
      "disabled": _vm.load
    },
    on: {
      "click": function($event) {
        return _vm.printAdminForm()
      }
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t('register.printForm')) + "\r\n                "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "userLoginField",
      "placement": "bottom",
      "triggers": "focus"
    }
  }, [_c('b-row', {
    staticClass: "m-0 p-2"
  }, [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userLoginRequirement.0')))]), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-2"
  }, [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userLoginRequirement.1')))]), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-2"
  }, [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userLoginRequirement.2')))]), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-2"
  }, [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userLoginRequirement.3')))]), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-2"
  }, [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userLoginRequirement.4')))])], 1)], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    attrs: {
      "id": "cancelRegistrationConfirmationModal",
      "ok-title": _vm.$t('forms.submit'),
      "cancel-title": _vm.$t('forms.cancel')
    },
    on: {
      "ok": _vm.cancelAccount
    }
  }, [_vm._v("\r\n            " + _vm._s(_vm.$t('userRegistration.registrationCancelConfirmationText')) + "\r\n        ")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "approveRegistrationConfirmationModal",
      "ok-title": _vm.$t('forms.submit'),
      "cancel-title": _vm.$t('forms.cancel')
    },
    on: {
      "ok": _vm.approveAccount
    }
  }, [_vm._v("\r\n            " + _vm._s(_vm.$t('userRegistration.registrationApproveConfirmationText')) + "\r\n        ")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "editInvoiceLimitModal",
      "ok-title": _vm.$t('forms.submit'),
      "cancel-title": _vm.$t('forms.cancel')
    },
    on: {
      "ok": _vm.editInvoiceLimit
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "col": ""
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userRegistration.invoiceLimitChangeText')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.invoiceLimit),
      callback: function($$v) {
        _vm.invoiceLimit = $$v
      },
      expression: "invoiceLimit"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1eb7ca44","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./src/components/home/user-registration/user-approval/user-approval.html
// module id = 755
// module chunks = 1